module.exports = __webpack_public_path__ + "img/pexels-hudson-marques-3378973.c7deff2b.jpg";